export function clientCaseFactFindPartnerPrintApi(path: string) {
  return {
    path,
  };
}
